
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.346 13.697a.998.998 0 001.413.002l4.222-4.237 4.222 4.249a.995.995 0 001.412-.002 1.01 1.01 0 00.002-1.42L9.397 8.04l4.311-4.328a1.007 1.007 0 00-.002-1.42.998.998 0 00-1.413-.001l-4.31 4.326-4.279-4.306a.995.995 0 00-1.411.002 1.01 1.01 0 00-.002 1.42L6.568 8.04l-4.224 4.24a1.007 1.007 0 00.002 1.418z"}})])
          )
        }
      }
    